import React from "react";
import { projectLinks } from "./../../portfolio";
import { ProjectCard } from "./../Cards/ProjectCard";
import styles from "./Projects.module.css";
import { darkTheme } from "./../../theme";
import { Heading } from "./../CategoryHeading/Heading";
import { List } from "antd";

export const Projects = () => {
  const theme = darkTheme;
  return (
    <div className={styles.projects_div_main} style={{ color: theme.text }}>
      {/* <Heading title="𝐏𝐫𝐨𝐣𝐞𝐜𝐭𝐬" /> */}
      {/* <div className={styles.projects_div} style={{ border: "5px solid lime" }}>
        {projectLinks.map((item) => (
          <ProjectCard item={item} />
        ))}
      </div> */}

      <div className={styles.cards_container}>
        <Heading title="𝐏𝐫𝐨𝐣𝐞𝐜𝐭𝐬" />
        <List
          style={{ marginTop: "2%", margin: "auto" }}
          grid={{
            gutter: 16,
            xs: 1,
            sm: 2,
            md: 3,
            lg: 3,
            xl: 3,
            xxl: 3,
          }}
          dataSource={projectLinks}
          renderItem={(item) => (
            <List.Item
              style={{
                // border: "1px solid black",
                alignItems: "center",
                marginTop: "10px",
              }}
            >
              <ProjectCard item={item} />
            </List.Item>
          )}
        />
      </div>
      <div className={styles.github_div}>
        <div className={`${styles.hideme} ${styles.github_div_elements}`}>
          <img
            align="center"
            src="https://github-readme-stats.vercel.app/api?username=SumanChakraborty1998&show_icons=true"
            alt="sumanchakraborty1998"
          />
        </div>

        <div className={styles.github_div_elements}>
          <img
            align="center"
            src="https://github-readme-stats.vercel.app/api/top-langs/?username=SumanChakraborty1998"
            alt="sumanchakraborty1998"
          />
        </div>
      </div>
      <br />
    </div>
  );
};
